
import {useSelector, useDispatch} from 'react-redux'
import { RootState } from "../../../../setup/redux/RootReducer";
import {useState,useEffect} from 'react' 
import {GetStoreList} from '../redux/StoreOperations'
import {setStoreList} from '../redux/StoreSlice'
import {setCurrentStore} from '../redux/CurrentStoreSlice' 




export default function StoreSelect() {

    const storeList = useSelector((state: RootState) => state.storeListReducer);
    const dispatch = useDispatch();
    const [detailErrorStr, setDetailErrorStr] = useState("");

    // const [previewLoading, setPreviewLoading] = useState(false)

    useEffect(() => {
        setDetailErrorStr("");
        // setPreviewLoading(false);
        const asynCall = async  () => {
            let response:any = await GetStoreList();
            console.log("Response =>", response);
            if(response.data != null){
                if(response.data.Status !="SUCCESS"){
                    setDetailErrorStr(response.data.Detail);
                }else{
                    dispatch(setStoreList(response.data.Detail));
                    console.log(response.data.Detail);
                }
            }else{
                setDetailErrorStr("Servis bağlantısı kurulamadı");
            }
        }
        asynCall();
    }, [])

    const handleSubmission = async () => {
        // setPreviewLoading(true);
        setDetailErrorStr("");

        // let response:any = await GetProductList();
        // if(response.data != null){
        //     if(response.data.Status !="SUCCESS"){
        //         setDetailErrorStr(response.data.Detail);
        //     }else{
        //         dispatch(setStoreList(response.data.Detail));
        //         console.log(response.data.Detail);
        //     }
        // }else{
        //     setDetailErrorStr("Servis bağlantısı kurulamadı");
        // }

        // setPreviewLoading(false);
    }
    async function  handleChangeStore(e:any)  {
        
        console.log("*******************************");
        console.log(e.target.data);
        const {name, value} = e.target;
        console.log("Value =>>",value+" ",name);
        
        if(value != "0"){
            let splittedValue = value.split("//");
            console.log("splitted =>",splittedValue)
            dispatch(setCurrentStore({storeNo: splittedValue[0],storeName:splittedValue[1]}))
        }
    }

    return(
        <div className='col-xxl-12' style={{marginBottom:15}}>
        <div className={`card card-xxl-stretch`} style={{height:'auto', minHeight:300}}>
                {/* begin::Header */}
            <div className='card-header align-items-center border-0 mt-4' style={{display:'block',overflow:'scroll',height:'auto'}}>
                <div style={{display:'flex',justifyContent:'center',marginTop:'3%'}}>
                    <h3 className='card-title align-items-start flex-column' style={{fontSize:'1.85em'}}>
                         Lütfen ürün aramak istediğiniz mağazayı seçin
                    </h3>
                </div>
             
                <div className='card-toolbar'>
                    <div className='card-body pt-5' style={{paddingLeft:0,marginBottom:15}}>
                        {/* <input type="file" name="file" onChange={changeHandler} /> */}
                        <div className="row gy-5 g-xl-8"> 
                         {detailErrorStr != "" && detailErrorStr != null &&  <div className="col-xxl-12">
                                <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                                    <span className="svg-icon svg-icon-2hx svg-icon-danger me-3">
                                        <span className="svg-icon svg-icon-2hx svg-icon-danger me-4">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                                <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
                                                <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                            </svg>
                                        </span>
                                    </span>
                                    <div className="d-flex flex-column">
                                        <h5 className="mb-1">Dikkat</h5>
                                        <span>{detailErrorStr}</span>
                                    </div>
                                </div>
                        </div>}
                        <div className="col-xxl-12" style={{}}>
                                <div className="row" style={{width:'100%',display:'flex',justifyContent:'center'}}>
                                    <div className="col-xxl-3">
                                            <select className="form-select" aria-label="Select example" name="" onChange={handleChangeStore} style={{padding:"0.40em 0.75em",maxWidth:250,height:'100%'}}>
                                                    <option value="0">Mağaza Seçiniz</option>
                                                    {storeList.storeList.map(x => 
                                                      <option value={x.storeNo + "//" + x.storeName}  key={x.storeNo}>{x.storeName}</option>
                                                    )}
                                            </select>
                                    </div>
                                    {/* <div className="col-xxl-2">
                                        <button className="btn btn-primary" onClick={handleSubmission} disabled={previewLoading} >
                                                <svg style={{ marginRight:3,width: 13,marginBottom:1}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                                </svg>
                                                {!previewLoading && <span className='indicator-label'>Seç</span>}
                                                {previewLoading && (
                                                    <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                                                    Yükleniyor...
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </span>
                                                )} 
                                        </button>
                                    </div> */}
                                </div>
                        </div>
                        {/* <div className="col-xxl-12">
                             <CustomerList></CustomerList>
                        </div> */}
                        </div>
                    </div> 
                </div>
            </div>
      </div>
      </div>
    )
}